module.exports = require("babel-core/polyfill");



/*****************
 ** WEBPACK FOOTER
 ** ./~/babel/polyfill.js
 ** module id = 311
 ** module chunks = 0
 **/